import { useUserFilter } from '@/components/user/hooks/useUserFilter'
import { useUsers } from '@/hooks/swr/useUsers'
import { debounce } from 'lodash-es'
import { onMounted, onUnmounted } from 'vue'

const EVENT_USER_SEARCH_PARAMS = {
  per_page: 25,
  sort_by: undefined,
  order_by: undefined,
}

export const useAddUserToDateSearch = () => {
  const { updateFilterParams, filterParams, resetFilterParams } =
    useUserFilter()

  updateFilterParams(EVENT_USER_SEARCH_PARAMS)

  const { users, usersCount, loading } = useUsers(filterParams)

  const searchUsers = debounce((search: string) => {
    updateFilterParams({ query: search })
  }, 350)

  onMounted(() => {
    resetFilterParams()
    updateFilterParams(EVENT_USER_SEARCH_PARAMS)
  })

  onUnmounted(() => {
    searchUsers.cancel()
    resetFilterParams()
  })

  return { users, usersCount, loading, searchUsers }
}
